export default __webpack_public_path__ + "static/media/arrow-up.f275ba1f.svg";